export default __webpack_public_path__ + "static/media/endorsement-bxp.7149e41c.png";